import styled from 'styled-components'

export const ThreatConsequenceModalContainer = styled.div`
    .form-group {
        margin-bottom: 16px;
    }

    .help-block {
        margin-top: 0;
    }
`
